// Employee financial health (design §14) — coaching framing over ledger truth.
// Renders nothing until there is a money story to tell (absence over emptiness).
import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@/features/shared/components/ui/card';
import { creditApi, type FinancialHealth } from '@/features/credit/api/creditApi';
import { formatMoney } from '../payroll/lib/format';

export function FinancialHealthStrip() {
  const [h, setH] = useState<FinancialHealth | null>(null);
  useEffect(() => {
    creditApi.financialHealth().then(setH).catch(() => setH(null));
  }, []);
  if (!h) return null;
  const hasStory = h.total_repaid > 0 || h.active_debt > 0 || h.interest_saved > 0 || h.products_completed > 0;
  if (!hasStory) return null;

  const items: { label: string; value: string; accent?: boolean }[] = [
    { label: 'Repaid so far', value: formatMoney(h.total_repaid, h.currency) },
    { label: 'Interest saved', value: formatMoney(h.interest_saved, h.currency), accent: h.interest_saved > 0 },
    { label: 'Active balance', value: formatMoney(h.active_debt, h.currency) },
    { label: 'Monthly deductions', value: formatMoney(h.monthly_deductions, h.currency) },
  ];
  return (
    <Card>
      <CardContent className="grid grid-cols-2 gap-3 p-4 sm:grid-cols-4">
        {items.map((it) => (
          <div key={it.label}>
            <p className={`text-sm font-bold tabular-nums ${it.accent ? 'text-emerald-600 dark:text-emerald-400' : 'text-foreground'}`}>{it.value}</p>
            <p className="text-[11px] text-muted-foreground">{it.label}</p>
          </div>
        ))}
        {h.products_completed > 0 && (
          <p className="col-span-full text-[11px] text-muted-foreground">
            {h.products_completed} product{h.products_completed > 1 ? 's' : ''} fully repaid — every completed product strengthens your KaziScore.
          </p>
        )}
      </CardContent>
    </Card>
  );
}
